(() => {
  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('buitre-premium-ready');

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.buitre-premium-reveal').forEach((el) => {
      el.classList.add('buitre-premium-visible');
    });
    return;
  }

  const selectors = [
    '.card-product',
    '.article-card',
    '.collection-card',
    '.multicolumn-card',
    '.testimonial-card',
    '.trust-points__item',
    '.product__info',
    '.cart__items',
    '.cart__footer',
    '.buitre-brand-story__media',
    '.buitre-brand-story__content',
    '.buitre-lookbook__card'
  ];

  const revealItems = () => {
    document.querySelectorAll(selectors.join(',')).forEach((el) => {
      if (!el.classList.contains('buitre-premium-reveal')) {
        el.classList.add('buitre-premium-reveal');
      }
    });
  };

  revealItems();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('buitre-premium-visible');
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.12
  });

  document.querySelectorAll('.buitre-premium-reveal').forEach((el, index) => {
    el.style.transitionDelay = `${Math.min(index % 6, 5) * 45}ms`;
    observer.observe(el);
  });

  document.addEventListener('shopify:section:load', () => {
    revealItems();
    document.querySelectorAll('.buitre-premium-reveal:not(.buitre-premium-visible)').forEach((el) => observer.observe(el));
  });
})();
